import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { FormGroup, FormControl } from '@angular/forms';
import { AppConfig } from '@appconfig';
import { HttpRepo } from '@shared/services/httprepo';

@Injectable()
export class LoginService {
    private fsUrl:string="";
    constructor(private http: HttpClient,private appConfig:AppConfig,private httpRepo:HttpRepo) {
        this.fsUrl=this.appConfig.getEndPoints().FieldServiceEndpointPrefix;
    }
    Hello() {
        return this.httpRepo.GetByAbsURL(this.fsUrl + "/hello");
    }
    Login(data:any){        
        return this.httpRepo.PostToAbsURL(this.fsUrl + "/login",data);
    }
    public noWhitespaceValidator(control: FormControl) {
        const isWhitespace = (control.value || '').trim().length === 0;
        const isValid = !isWhitespace;
        return isValid ? null : { 'required': true };
    }
    public markFormGroupTouched(formGroup: FormGroup) {
        (<any>Object).values(formGroup.controls).forEach(control => {
            control.markAsTouched();

            if (control.controls) {
                this.markFormGroupTouched(control);
            }
        });
    }
}